export const c_form_m_limit_width_MaxWidth = {
  "name": "--pf-v6-c-form--m-limit-width--MaxWidth",
  "value": "55rem",
  "var": "var(--pf-v6-c-form--m-limit-width--MaxWidth)"
};
export default c_form_m_limit_width_MaxWidth;